import UAParser from 'ua-parser-js';

interface AppStrategy {
    mmq: string;
    pregnancyhelper: string;
    gzq: string;
    gzm: string;
    record: string;
    mmgoods: string;
    mamaApp?: string;
}

interface App {
    mmq: boolean;
    pregnancyhelper: boolean;
    gzq: boolean;
    gzm: boolean;
    mmgoods: boolean;
    mamaApp: boolean;
    app: string;
    appVer: string;
    wx: boolean;
    wxwork: boolean;
    default: UAParser.IResult;
}

interface StrategySetUASuccess {
    (i: string): void;
}
interface StrategySetUADone {
    (): void;
}

function strategySetUA(strategy: AppStrategy, app: App, success: StrategySetUASuccess, done: StrategySetUADone) {
    let i, reg, flag;
    for (i in strategy) {
        if (Object.prototype.hasOwnProperty.call(strategy, i)) {
            reg = new RegExp(strategy[i], 'ig');
            app[i] = flag = reg.test(navigator.userAgent);
            if (flag) {
                success(i);
            }
        }
    }
    done();
}

export default {
    getUA: () => {
        const appStrategy: AppStrategy = {
                mmq: 'mmq/',
                pregnancyhelper: 'pregnancyhelper/',
                gzq: 'gzq/',
                gzm: 'gzm/',
                record: 'recordapp/',
                mmgoods: 'mmgoods/'
            },
            wx = '^(?!.*wxwork).*micromessenger',
            wxwork = 'wxwork',
            appVerStrategy = '([0-9.]*)',
            app: App = {
                mmq: false,
                pregnancyhelper: false,
                gzq: false,
                gzm: false,
                mmgoods: false,
                mamaApp: false,
                app: '',
                appVer: '0',
                wx: false,
                wxwork: false,
                default: new UAParser().getResult()
            };

        const mamaApp = [];
        for (const k in appStrategy) {
            mamaApp.push(`|${appStrategy[k]}`);
        }

        appStrategy.mamaApp = mamaApp.join('').substr(1);

        strategySetUA(
            appStrategy,
            app,
            function (i: string) {
                if (i !== 'mamaApp') {
                    app.app = i;
                }
            },
            function () {
                if (app.app) {
                    const reg = new RegExp(appStrategy[app.app] + appVerStrategy, 'ig');
                    if (reg.test(navigator.userAgent)) {
                        app.appVer = RegExp['$1'];
                    }
                }
            }
        );

        app.wx = new RegExp(wx, 'ig').test(navigator.userAgent);
        app.wxwork = new RegExp(wxwork, 'ig').test(navigator.userAgent);

        return app;
    }
};
